export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/rate.33d4d2c2.svg","height":302,"width":462};